import axios, { AxiosInstance, AxiosProgressEvent, AxiosResponse, Method } from 'axios'

interface ApiCallProps {
    method?: Method
    data?: object | string
    url: string
    baseURL?: string
    headers?: { [key: string]: string }
    params?: { [key: string]: string | string[] | number | boolean }
    paramsSerializer?: any
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
}

export default class Api {
    private static _instance: Api | null = null
    private api!: AxiosInstance
    private authData?: unknown

    public static getInstance(): Api {
        if (!(Api._instance instanceof Api)) {
            throw new Error('Api not initialized yet')
        }

        return Api._instance
    }

    public static destroyInstance(): void {
        Api._instance?.destroy()
        Api._instance = null
    }

    constructor({ apiUrl }: { apiUrl: string }) {
        if (Api._instance) {
            return Api._instance
        }

        Api._instance = this
        Api._instance.api = axios.create({
            baseURL: apiUrl,
        })

        /* Api._instance.api.interceptors.request.use(async (request) => {
            const session = await getSession()
            if (session) {
                request.headers = {
                    ...request.headers,
                    Authorization: `Bearer ${session.accessToken}`,
                }
            }
            return request
        }) */

        Api._instance.api.interceptors.response.use(
            (response) => response,
            async (err: { response?: AxiosResponse<any> }): Promise<unknown> => {
                console.log('Error making requests', err.response?.data || err)

                if (err?.response?.status === 401 && err.response?.data?.message === 'jwt expired') {
                    console.log('token expired')
                }

                throw err
            },
        )

        return Api._instance
    }

    public setAuthData(authData: { token: string }): void {
        if (Api._instance) {
            Api._instance.authData = authData
            Api._instance.api.defaults.headers.common['Authorization'] = `Bearer ${authData.token}`
        } else {
            throw new Error('Api not initialized')
        }
    }

    public deleteAuthData(): void {
        if (Api._instance) {
            Api._instance.authData = undefined
            Api._instance.api.defaults.headers.common['Authorization'] = ''
        } else {
            throw new Error('Api not initialized')
        }
    }

    private _call({
        method = 'get',
        data,
        url,
        baseURL,
        headers,
        params,
        onUploadProgress,
    }: ApiCallProps): Promise<AxiosResponse> | undefined {
        return Api._instance?.api.request({
            method: method || 'get',
            data,
            url,
            baseURL,
            headers,
            params,
            onUploadProgress,
        })
    }

    public async call(props: ApiCallProps): Promise<AxiosResponse> {
        const resp = await Api._instance?._call(props)
        if (resp !== undefined) {
            return resp
        } else {
            throw new Error('Api error')
        }
    }

    public destroy(): void {
        this.destroy()
    }
}
